import CalendarApproval from "@/business/calendar/CalendarApproval";
import CalendarConfirm from "@/business/calendar/CalendarConfirm";
import CalendarMain from "@/business/calendar/CalendarMain";
import { LayoutHeader } from "@/Header";
import { Tabs } from "@/Tabs";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTab } from "^/common/useTab";
import { useCallback, useState } from "react";
import MessageModal from "@/MessageModal";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
import useOpenModal from "^/common/useOpenModal";

export const Route = createFileRoute("/business/layout/calendar")({
  component: Calendar,
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: search.tab != null ? String(search.tab) : undefined,
  }),
});

function Calendar() {
  const navigate = useNavigate();
  const { tab: initialTab } = Route.useSearch();
  const { tab, handleTab: setTabLocal, tabList } = useTab(
    ["캘린더 보기", "승인 대기", "확정 예약"],
    initialTab
  );

  // 탭을 URL에 동기화(replace) — 상세 진입 후 뒤로가기 시 보던 탭이 복원되고,
  // 탭 전환 자체는 히스토리에 쌓이지 않는다
  const handleTab = (next: string) => {
    setTabLocal(next);
    navigate({
      to: "/business/layout/calendar",
      search: { tab: next },
      replace: true,
    });
  };

  // 공통 날짜 상태 관리
  const [sharedDate, setSharedDate] = useState(() => {
    const today = new Date();
    return {
      year: today.getFullYear(),
      month: today.getMonth(),
      day: today.getDate(),
    };
  });
  const { isOpenModal, clickModal, closeModal } = useOpenModal();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleOkClick = useCallback(
    (day: Date | null) => {
      console.log({
        year: day?.getFullYear() || 0,
        month: day?.getMonth() || 0,
        day: day?.getDate() || 0,
      });
      setSharedDate({
        year: day?.getFullYear() || 0,
        month: day?.getMonth() || 0,
        day: day?.getDate() || 0,
      });
      closeModal();
    },
    [closeModal]
  );

  return (
    <>
      <LayoutHeader title={"예약 관리"} hasFootPrint={false} />
        <div className="flex-auto bg-[#F5F5F5]">
            <Tabs tabList={tabList} handleTab={handleTab} tab={tab} tabBg="bg-white">
              <CalendarMain sharedDate={sharedDate} setSharedDate={setSharedDate} />
              <CalendarApproval
                sharedDate={sharedDate}
                setSharedDate={setSharedDate}
                clickModal={clickModal}
              />
              <CalendarConfirm
                sharedDate={sharedDate}
                setSharedDate={setSharedDate}
                clickModal={clickModal}
              />
            </Tabs>
        {/* 달력 모달 */}
        <MessageModal
          isOpen={isOpenModal}
          onRequestClose={closeModal}
          className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none"
          overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          shouldCloseOnOverlayClick={false}
        >
          <CalendarComponent
            disabled={false}
            dayOnClick={(day) => {
              setSelectedDate(day);
            }}
            selectedDay={selectedDate}
            schedules={{}}
          />
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={closeModal}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={() => handleOkClick(selectedDate)}
            >
              확인
            </button>
          </div>
        </MessageModal>
      </div>
    </>
  );
}
